import { render, staticRenderFns } from "./safe-time.vue?vue&type=template&id=f3770568&scoped=true&"
import script from "./safe-time.vue?vue&type=script&lang=js&"
export * from "./safe-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3770568",
  null
  
)

export default component.exports